import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import ImprensaList from '../components/ImprensaList'

export const ImprensaPage = ({ data, location }) => {
  const area = 'O Santa Joana'
  const { edges: Imprensa } = data.allWpMateria
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: '#', title: 'Imprensa' },
  ]
  return (
    <Layout>
      <ImprensaList imprensa={Imprensa} title="Imprensa" crumbs={crumbs} />
    </Layout>
  )
}

ImprensaPage.propTypes = {
  data: PropTypes.shape({
    allWpImprensa: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
  pageContext: PropTypes.shape({
    currentPage: PropTypes.number,
    numPages: PropTypes.number,
  }),
}

export default ImprensaPage

export const pageQuery = graphql`
  query ImprensaQuery($limit: Int!, $skip: Int!) {
    allWpMateria(
      sort: { fields: date, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          excerpt
          Imprensa {
            linkExterno
            data
          }
        }
      }
    }
  }
`
